import { Comment, CommentProperty, CommentStatus } from "@/services/comments";

function* reverseLookup(comments: Comment[]): Generator<Comment> {
  let length = comments.length;
  while (length > 0) {
    --length;
    const comment = comments[length];
    yield comment;
    if (comment.children?.length > 0) {
      yield* reverseLookup(comment.children);
    }
  }
}

export const flatCommentThread = (comments: Comment[]): Comment[] => [...reverseLookup(comments)];

export const findCommentById = (comments: Comment[] | null, id: string) => {
  if (!comments) {
    return null;
  }
  let result: Comment | null = null;
  for (const comment of reverseLookup(comments)) {
    if (comment.id === id) {
      result = comment;
      break;
    }
  }
  return result;
};

export const addCommentProperty = (comment: Comment, commentProperty: CommentProperty) => {
  comment.commentProperties.push(commentProperty);
};
export const removeCommentProperty = (comment: Comment, commentProperty: CommentProperty) => {
  const index = comment.commentProperties.indexOf(commentProperty);

  comment.commentProperties.splice(index, 1);
};

export const findCommmentsById = (comments: Comment[] | null, ids: string[]) => {
  if (!comments) {
    return [];
  }

  let result: Comment[] = [];
  ids.forEach((id) => {
    const comment = findCommentById(comments, id);
    if (comment) {
      result.push(comment);
    }
  });
  return result;
};
